import { useState, type FormEvent } from 'react';
import Aviso from '../componentes/Aviso';
import Marca from '../componentes/Marca';
import { mensagemDeErro, supabase } from '../lib/supabase';

// A porta do portal. Não há "criar conta" de propósito: quem cria o acesso é
// a loja (rota /infra/v1/parceiros do agente) — cadastro fechado, decisão do
// dono. Esqueceu a senha = ligar para a loja, que redefine na hora.
export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  const entrar = async (e: FormEvent) => {
    e.preventDefault();
    setErro(null);
    setEntrando(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password: senha });
    setEntrando(false);
    if (error) setErro(mensagemDeErro(error));
  };

  return (
    <div className="mx-auto flex min-h-svh max-w-md flex-col justify-center gap-6 p-6">
      <div className="flex items-center gap-3">
        <Marca className="h-9 w-auto text-signal" />
        <div>
          <p className="text-lg font-black leading-tight">SERGINHO</p>
          <p className="text-xs uppercase tracking-widest text-dim">Portal do parceiro</p>
        </div>
      </div>

      <form className="cartao space-y-4 p-5" onSubmit={entrar}>
        <div>
          <label className="rotulo" htmlFor="email">E-mail</label>
          <input id="email" type="email" className="campo" value={email} autoComplete="username"
                 onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <label className="rotulo" htmlFor="senha">Senha</label>
          <input id="senha" type="password" className="campo" value={senha}
                 autoComplete="current-password"
                 onChange={(e) => setSenha(e.target.value)} required />
        </div>
        {erro && <Aviso tipo="erro">{erro}</Aviso>}
        <button type="submit" className="botao-primario w-full py-2.5 text-sm" disabled={entrando}>
          {entrando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>

      <p className="text-center text-xs text-dim">
        Ainda não tem acesso, ou esqueceu a senha? Fale com a
        Serginho Autopeças — a loja cria e redefine na hora.
      </p>
    </div>
  );
}
